import { useState } from 'react';
import { createContexts } from '@/js/libs/create-contexts/index.ts';
export const { usePuzzleNavigationContext } = createContexts({
    PuzzleNavigation({ isCollapsedNav, collapseMainNav }) {
        const [activeKey, setActiveKey] = useState(null);
        return {
            activeKey,
            setActiveKey,
            isCollapsedNav,
            collapseMainNav,
        };
    },
});
